import { Box, styled } from "@mui/material";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";

import PageContainer from "~frontend/components/PageContainer";
import theme, { palette } from "~frontend/theme";

import CampaignMessageStatusBreakdown from "./messageStatusBreakdown";

const SectionWrapper = styled(Box)({
  backgroundColor: palette.lightestGray,
  padding: `${theme.spacing(4)} ${theme.spacing(7)}`,
});

export function CampaignErrors(): ReactElement {
  const { campaignShortId: maybeCampaignShortId } = useParams<{
    campaignShortId: string;
  }>();
  const campaignShortId = parseInt(maybeCampaignShortId!);

  return (
    <PageContainer
      maxWidth="lg"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
      }}
    >
      <SectionWrapper sx={{ backgroundColor: palette.white }}>
        <h2>Errors</h2>
        <CampaignMessageStatusBreakdown campaignShortId={campaignShortId} />
      </SectionWrapper>
    </PageContainer>
  );
}
